/**
 * Parses and cleans API response data that might be returned as a string
 * @param {string|object} data - The API response data to parse
 * @returns {object} The parsed JSON data
 * @throws {Error} If parsing fails
 */
export const parseApiResponse = (data) => {
    // If data is already an object, return it
    if (typeof data !== 'string') {
        return data;
    }

    try {
        // First try direct parsing
        try {
            return JSON.parse(data);
        } catch (e) {
            // If direct parsing fails, try cleaning the string first
            console.log("Direct JSON parse failed, attempting to clean string");
            let cleanedData = data
                .replace(/[\r\n\t]/g, '')
                .trim()
                // Remove any potential BOM characters
                .replace(/^\uFEFF/, '');

            // Try to find where the actual JSON starts
            const jsonStart = cleanedData.indexOf('{');
            const jsonEnd = cleanedData.lastIndexOf('}');
            if (jsonStart >= 0 && jsonEnd >= 0) {
                cleanedData = cleanedData.slice(jsonStart, jsonEnd + 1);
            }

            const parsedData = JSON.parse(cleanedData);
            return parsedData;
        }
    } catch (parseError) {
        console.error("JSON Parse Error:", parseError);
        console.log("Problematic JSON string:", data.slice(0, 200) + "..."); // Log first 200 chars
        throw new Error(`Failed to parse JSON: ${parseError.message}`);
    }
};

/**
 * Validates that all required portal content fields are present
 * @param {object} data - The parsed portal content data
 * @throws {Error} If any required fields are missing
 */
export const validatePortalContent = (data) => {
    const requiredFields = [
        'house_categories',
        'icons',
        'datapoints',
        'projects',
        'resources',
        'companies'
    ];

    const missingFields = requiredFields.filter(field => !data[field]);
    
    if (missingFields.length > 0) {
        throw new Error(`Missing required data fields: ${missingFields.join(', ')}`);
    }

    return data;
};
